/**
 * Sermorelin Product Configuration with Environment-based Product Bundle IDs
 * 
 * Returns product configurations with productBundleId values that differ
 * between staging and production environments.
 * 
 * Sermorelin is a single product (no dosage variants like 500mg/1000mg).
 * 
 * Pricing (validated against CareValidate API):
 * - Monthly: $199
 * - 3 Month Bundle: $537 ($179/mo)
 * - 6 Month Bundle: $996 ($166/mo)
 * - 12 Month Bundle: $1,500 ($125/mo)
 * 
 * Environment Detection:
 * - Uses VITE_CAREVALIDATE_API_URL to determine environment
 * - Staging: api-staging.care360-next.carevalidate.com
 * - Production: api.care360-next.carevalidate.com
 */

/**
 * Get Sermorelin products configuration with environment-specific productBundleId
 * @returns {Object} Product catalog configuration
 */
export function getCvSermorelinProductsConfig() {
  const isProduction = import.meta.env.VITE_CAREVALIDATE_API_URL?.includes('api.care360-next.carevalidate.com')
  
  return {
    product_7: {
      id: "product_7",
      name: "Sermorelin Injection",
      display_name: "Sermorelin",
      another_name: "Sermorelin Injection",
      type: "injection",
      medication: "sermorelin",
      isVisible: true,
      default: true,
      price: 159.00,
      productId: isProduction ? "6941e575-ec50-4c53-999b-b97e302f4bfb" : "d6d00fd2-f19a-412f-a3ff-aaedcfeac967",
      productBundleId: isProduction 
        ? "636b25ed-8e5c-4e52-b031-55948523cdb2"
        : "5433f0ca-864b-4fd3-84d0-55ba682827a6",
      imageUrl: "/images/products/sermorelin.png",
      imageUrl2: "/images/products/sermorelin.png",
      description: "Boost your body's natural growth hormone production.",
      badge: "Recommended",
      badgeIcon: "/images/funnel3/bmi-checkout/charger.png",
      badgeColor: "#147FF1",
      imageBg: "#CBD5E1",
      tagline: "Boost your body's natural growth hormone production.",
      patientCountMin: 600,
      patientCountMax: 900,
      pricePlan: {
        monthly: {
          months: 1,
          price: 159.00,
          pricePerMonth: 159.00,
          regularPrice: 227.00,
          regularPricePerMonth: 227.00,
          productId: isProduction ? "6941e575-ec50-4c53-999b-b97e302f4bfb" : "d6d00fd2-f19a-412f-a3ff-aaedcfeac967",
          productBundleId: isProduction 
            ? "636b25ed-8e5c-4e52-b031-55948523cdb2"
            : "5433f0ca-864b-4fd3-84d0-55ba682827a6",
          supplyLabel: "30 Day Supply"
        },
        quarterly: {
          months: 3,
          price: 447.00,
          pricePerMonth: 149.00,
          regularPrice: 639.00,
          regularPricePerMonth: 213.00,
          productId: isProduction ? "6941e575-ec50-4c53-999b-b97e302f4bfb" : "d6d00fd2-f19a-412f-a3ff-aaedcfeac967",
          productBundleId: isProduction 
            ? "f5d3adb8-9e32-4f40-a3a3-e5ba56c08717"
            : "180db936-f9a9-430c-92b6-169290d3a605",
          buttonLabel: "Best Value",
          supplyLabel: "90 Day Supply"
        },
        sixMonth: {
          months: 6,
          price: 834.00,
          pricePerMonth: 139.00,
          regularPrice: 1194.00,
          regularPricePerMonth: 199.00,
          productId: isProduction ? "6941e575-ec50-4c53-999b-b97e302f4bfb" : "d6d00fd2-f19a-412f-a3ff-aaedcfeac967",
          productBundleId: isProduction 
            ? "4ac4d06c-c050-40a4-a96a-c9111e72f951"
            : "bb29aedf-e851-44df-8f94-9f19d0f74355",
          supplyLabel: "6 Month Supply"
        },
        annual: {
          months: 12,
          price: 1548.00,
          pricePerMonth: 129.00,
          regularPrice: 2208.00,
          regularPricePerMonth: 184.00,
          productId: isProduction ? "6941e575-ec50-4c53-999b-b97e302f4bfb" : "d6d00fd2-f19a-412f-a3ff-aaedcfeac967",
          productBundleId: isProduction 
            ? "80f53b7d-50ee-48bc-82f3-c56ff26f1e6d"
            : "f4ac26b8-ab72-4d38-a818-87607e3c2867",
          supplyLabel: "12 Month Supply"
        }
      }
    }
  }
}

// Default export for backward compatibility with JSON import syntax
export default getCvSermorelinProductsConfig()
